export default __webpack_public_path__ + "static/media/photo--lg--133.bfad3387.jpg";